// extracted by mini-css-extract-plugin
export default {"root":"CategoryAvailibility_root__naQmj","delete-icon":"CategoryAvailibility_delete-icon__GXup1","enabledisable":"CategoryAvailibility_enabledisable__q1G9C"};